<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box">
      <!-- <div class="select-label">欢视商店是TCL、长虹、海尔电视的系统商店，上下架状态及应用信息一致</div> -->
    </div>
    <div class="app-list" v-show="!isShowInfo">
      <Card class="app-item" :id="'scroll' + item.id" v-for="(item, index) in dataList" :key="index">
        <div class="text-center">
          <div class="app-info">
            <img :src="item.icon">
            <h3>{{item.name}}</h3>
            <p><strong style="color: #19be6b">包名</strong> {{item.package_name}}</p>
            <p>{{item.update_at}}</p>
            <Button type="info" size="small" class="app_aduit_info" @click="showInfo(item, '1')">应用详情</Button>
            <Button type="info" size="small" class="app_aduit_channel" @click="showChannel(item)">查看渠道</Button>
            <Button type="success" size="small" v-show="item.store_status === 0" class="app_aduit_updata" @click="showInfo(item, '2')">申请上架</Button>
            <Button type="success" size="small" v-show="item.store_status === 1 || item.store_status === 2" class="app_aduit_updata" @click="showInfo(item, '2')">更新</Button>
          </div>
        </div>
      </Card>
    </div>
    <div v-show="isShowInfo">
      <Button type="primary" class="back_list" @click="backList">返回</Button>
      <Form ref="appDetails" :model="appDetails" :rules="ruleValueDeails" :label-width="120">
        <div class="app_details_title">应用信息</div>
        <div class="app_details_infobox">
          <FormItem label="应用名称" prop="app_name">
            <Input v-model="appDetails.app_name" :disabled="flag_type === FLAGTYPE" class="app_details_input_width" placeholder="请输入应用名称，2-20个字" />
          </FormItem>
          <FormItem label="应用类型" prop="app_type">
            <Select v-model="appDetails.app_type"  :disabled="flag_type === FLAGTYPE" style="width:100px" clearable @on-change="selectChange">
              <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="牌照方名称" v-if="strType === '908'" prop="license_plate_name">
            <Select v-model="appDetails.license_plate_name"  :disabled="flag_type === FLAGTYPE" style="width:100px" clearable>
              <Option v-for="item in licenseTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="牌照方证明" v-if="strType === '908'" prop="license_pdf ">
            <div class="picWrap">
              <img :src="appDetails.license_pdf " width="100%">
              <Icon class="clearPic" size="25" v-show="appDetails.license_pdf " type="md-close-circle" @click="clearPic" />
            </div>
            <div>
              <label class="file-wrap">
                <input class="file-input" type="file" ref="file" accept="image/png, image/jpeg"
                      multiple="multiple" @change="uploadImg('file','PDF')" />
                <Button icon="ios-cloud-upload-outline" v-show="flag_type !== FLAGTYPE">上传文件</Button>
              </label>
            </div>
            <div class="tips">支持jpg/png格式文件，不超过5M</div>
          </FormItem>
          <FormItem label="软著证书编号" v-if="strType === '908'" prop="software_num">
            <Input v-model="appDetails.software_num"  :disabled="flag_type === FLAGTYPE" class="app_details_input_width" placeholder="请输入软著证书编号" />
          </FormItem>
          <FormItem label="一句话简介" prop="app_introduce">
            <Input v-model="appDetails.app_introduce"  :disabled="flag_type === FLAGTYPE" class="app_details_input_width" placeholder="请输入一句话简介" />
          </FormItem>
          <FormItem label="搜索关键字" prop="app_keyword">
            <Input v-model="appDetails.app_keyword" :disabled="flag_type === FLAGTYPE" class="app_details_input_width" placeholder="请输入搜索关键字" />
            <div class="tips" >用户可通过关键字搜索到应用,多个关键字用英文逗号隔开</div>
          </FormItem>
          <FormItem label="应用介绍" prop="app_description">
            <Input v-model="appDetails.app_description" :disabled="flag_type === FLAGTYPE" class="app_details_input_width" type="textarea" :rows="4" placeholder="请输入应用介绍" />
          </FormItem>
        </div>
        <div class="app_details_title">安装包上传</div>
        <div class="app_details_infobox">
          <FormItem label="渠道" prop="operate_type">
            <CheckboxGroup v-model="channelList">
              <Checkbox  :disabled="true" label="长虹"></Checkbox>
              <Checkbox  :disabled="true" label="TCL"></Checkbox>
              <Checkbox  :disabled="true" label="海尔"></Checkbox>
          </CheckboxGroup>
          </FormItem>
          <FormItem label="应用包名" prop="app_pkg">
            <Input v-model="appDetails.app_pkg" :disabled="appPkgFlag || flag_type === FLAGTYPE" class="app_details_input_width" placeholder="请输入应用包名" />
            <div class="tips">包名一旦保存不可更改</div>
          </FormItem>
          <!-- :disabled="true" -->
          <!-- es_app_pkg -->
          <!-- <FormItem label="应用版本号" prop="remark7">
            <Input v-model="appDetails.remark7" class="app_details_input_width" placeholder="请输入应用版本号" />
          </FormItem> -->
        </div>
        <div>
          <FormItem label="应用icon" prop="app_icon">
            <div class="picWrap">
              <img :src="appDetails.app_icon" width="100%">
              <Icon class="clearPic" size="25" v-show="appDetails.app_icon" type="md-close-circle" @click="clearPic" />
            </div>
            <div>
              <label class="file-wrap">
                <input class="file-input" type="file" ref="file" accept="image/png, image/jpeg"
                      multiple="multiple" @change="uploadImg('file','ICON')" />
                <Button icon="ios-cloud-upload-outline" v-show="flag_type !== FLAGTYPE">上传文件</Button>
              </label>
            </div>
            <div class="tips">支持jpg/png格式文件，不超过5M</div>
          </FormItem>
        </div>
        <div>
          <FormItem label="应用截图" prop="app_pics">
            <div class="picWrap" v-for="(item, index) in appDetails.app_pics" :key="index">
            <img :src="item" width="100%">
            <Icon class="clearPic" size="25" type="md-close-circle" @click="clearPicList(index)" />
          </div>
            <div>
              <label class="file-wrap">
                <input class="file-input" type="file" ref="fileList" accept="image/png, image/jpeg"
                      multiple="multiple" @change="uploadImgList('fileList')" />
                <Button icon="ios-cloud-upload-outline" v-show="flag_type !== FLAGTYPE">上传文件</Button>
              </label>
            </div>
            <div class="tips">请上传4到5张应用截图，支持jpg/png格式文件，不超过5M</div>
          </FormItem>
        </div>
        <div class="app_details_infobox">
          <FormItem label="隐私协议" prop="privacy_policy">
            <Input v-model="appDetails.privacy_policy" :disabled="flag_type === FLAGTYPE" class="app_details_input_width" type="textarea" :rows="4" placeholder="请输入隐私协议" />
          </FormItem>
          <FormItem label="更新说明" prop="upgrade_remark">
            <Input v-model="appDetails.upgrade_remark" :disabled="flag_type === FLAGTYPE" class="app_details_input_width" type="textarea" :rows="4" placeholder="请输入更新说明" />
          </FormItem>
        </div>
        <div class="app_details_title">适配信息</div>
        <div>
          <FormItem label="交互方式" prop="operate_type">
            <CheckboxGroup v-model="appDetails.operate_type">
              <Checkbox label="键盘"></Checkbox>
              <Checkbox label="鼠标"></Checkbox>
              <Checkbox label="遥控器"></Checkbox>
              <Checkbox label="体感"></Checkbox>
              <Checkbox label="手柄"></Checkbox>
              <Checkbox label="摄像头"></Checkbox>
              <Checkbox label="多屏互动"></Checkbox>
          </CheckboxGroup>
          </FormItem>
          <FormItem label="付款方式" prop="pay_type">
            <RadioGroup v-model="appDetails.pay_type">
              <Radio :disabled="flag_type === FLAGTYPE" :label="1">免费</Radio>
              <Radio :disabled="flag_type === FLAGTYPE" :label="2">内购付费</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="支持语言" prop="language">
            <RadioGroup v-model="appDetails.language">
              <Radio :disabled="flag_type === FLAGTYPE" :label="1">中文</Radio>
              <Radio :disabled="flag_type === FLAGTYPE" :label="2">英文</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="运营方式" prop="oper_type">
            <RadioGroup v-model="appDetails.oper_type">
              <Radio :disabled="flag_type === FLAGTYPE" :label="1">在线</Radio>
              <Radio :disabled="flag_type === FLAGTYPE" :label="2">单机</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="支付SDK" prop="pay_sdk">
            <RadioGroup v-model="appDetails.pay_sdk">
              <Radio :disabled="flag_type === FLAGTYPE" :label="1">未集成</Radio>
              <Radio :disabled="flag_type === FLAGTYPE" :label="2">已集成</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="广告SDK" prop="adv_sdk">
            <RadioGroup v-model="appDetails.adv_sdk">
              <Radio :disabled="flag_type === FLAGTYPE" :label="1">未集成</Radio>
              <Radio :disabled="flag_type === FLAGTYPE" :label="2">已集成</Radio>
            </RadioGroup>
          </FormItem>
        </div>
        <div class="app_details_infobox" v-show="flag_type !== FLAGTYPE">
          <FormItem>
            <Button type="primary" :loading="submitLoading" @click="submit('ts')">保存</Button>
          </FormItem>
          <FormItem>
            <Button type="primary" :loading="submitLoading" @click="submit('submit')">保存并提交</Button>
          </FormItem>
        </div>
      </Form>
    </div>
    <Modal
      width="800"
      :mask-closable="false"
      v-model="isShowChannel"
      title="查看渠道"
      :footer-hide="true"
      >
      <Table class="spacingTwice" border :columns="columns" :data="dataChannelList"></Table>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      mobileApp: [],
      dataChannelList: [],
      editId: '',
      editItem: '',
      userId: '',
      userList: [],
      userInfoId: '',
      currentIndex: '',
      strType: '',
      formValidate: {
        name: '',
        remark: '',
        package_name: '',
        icon: '',
        files: '',
        fileName: '',
        pre_pwd: ''
      },
      submitLoading: false,
      isShowChannel: false,
      appPkgFlag: false,
      typeList: [],
      channelList: ['长虹', 'TCL', '海尔'],
      FLAGTYPE: '1',
      appDetails: {
        app_icon: '',
        app_pics: [],
        app_name: '',
        es_app_pkg: '',
        app_introduce: '',
        app_description: '',
        app_keyword: '',
        upgrade_remark: '',
        app_pkg: '',
        privacy_policy: '',
        operate_type: [],
        pay_type: 1,
        language: 3,
        oper_type: 1,
        pay_sdk: 1,
        adv_sdk: 1
      },
      licenseTypeList: [
        {
          id: 1,
          name: '未来电视有限公司'
        },
        {
          id: 2,
          name: '百事通网络电视技术发展有限责任公司'
        },
        {
          id: 3,
          name: '华数传媒网络有限公司'
        },
        {
          id: 4,
          name: '广东南方新媒体股份有限公司'
        },
        {
          id: 5,
          name: '快乐阳光互动娱乐传媒有限公司'
        },
        {
          id: 6,
          name: '国广东方网络(北京)公司'
        },
        {
          id: 7,
          name: '银河互联网电视有限公司'
        }
      ],
      ruleValueDeails: {
        app_name: [
          { required: true, message: '请输入应用名称' }
        ],
        app_pkg: [
          // { required: true, message: '请输入应用包名' }
          { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.test' }
        ],
        app_introduce: [
          { required: true, message: '请输入一句话简介' }
        ],
        app_description: [
          { required: true, message: '请输入应用介绍' }
        ],
        upgrade_remark: [
          { required: false, message: '请输入更新说明' }
        ],
        privacy_policy: [
          { required: true, pattern: /^(http)/g, message: '示例：http://www.baidu.com' }
        ],
        app_keyword: [
          { required: true, message: '请输入搜索关键字' }
        ],
        app_icon: [
          { required: true, message: '请上传应用图标' }
        ],
        app_pics: [
          { required: true, type: 'array', min: 4, max: 5, message: '上传截图数量为4-5张' }
        ],
        license_plate_name: [
          { required: this.strType === 908 ? 'true' : 'false', message: '请选择牌照方名称' }
        ]
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 20, min: 2, message: '请输入2-20个字', trigger: 'blur' }
        ],
        pre_pwd: [
          { required: true, message: '请输入预览密码', trigger: 'blur' },
          { type: 'string', max: 32, message: '长度最多32位', trigger: 'blur' }
        ]
      },
      columns: [ // 版本管理table表格
        {
          title: '渠道',
          key: 'channel_name',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '最新版本',
          key: 'vername',
          width: 220,
          align: 'center'
        },
        {
          title: '应用状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 0:
                status = '待审核'
                break
              case 1:
                status = '审核中'
                break
              case 2:
                status = '已打回'
                break
              case 3:
                status = '已发布'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '更新时间',
          key: 'updated_at',
          width: 220,
          align: 'center'
        },
        {
          title: '操作',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            if (params.row.status === 2) {
              btn = [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: params.row.remark,
                        onOk: () => {
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '查看原因')
              ]
            }
            return h('div', btn)
          }
        }
      ],
      isShowInfo: false,
      dataSource: [], // table数据源
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 100, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.role_id = window.localStorage.getItem('role_id')
    this.userId = window.localStorage.getItem('userId')
    this.getUserList()
    this.getTypeList()
    // this.getQualification().then(this.loadData)
    this.loadData()
  },
  mounted () {
  },
  methods: {
    backList () {
      this.appDetails = {
        app_icon: '',
        app_pics: [],
        app_name: '',
        es_app_pkg: '',
        app_introduce: '',
        app_description: '',
        app_keyword: '',
        upgrade_remark: '',
        privacy_policy: '',
        operate_type: [],
        app_pkg: '',
        pay_type: 1,
        language: 3,
        oper_type: 1,
        pay_sdk: 1,
        adv_sdk: 1
      }
      this.appPkgFlag = false
      this.isShowInfo = false
    },
    getTypeList () {
      https.request({
        method: 'get',
        url: '/v2/es/store/app/types',
        params: {}
      }).then(res => {
        this.typeList = res.data
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    clearPic () {
      this.appDetails.app_icon = ''
    },
    clearPicList (index) {
      this.appDetails.app_pics.splice(index, 1)
    },
    showChannel (item) {
      console.log(item)
      this.isShowChannel = true
      // let pkg = ''
      // if (item.apk_pkg.length === 0) {
      //   if (item.sd_pkg_name.length === 0) {
      //     pkg = item.package_name
      //   } else {
      //     pkg = item.sd_pkg_name
      //   }
      // } else {
      //   pkg = item.apk_pkg
      // }
      https.request({
        method: 'get',
        url: '/v2/es/store/app/channels',
        params: {
          es_app_pkg: item.package_name
        }
      }).then(res => {
        this.dataChannelList = res.data
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    selectChange (val) {
      this.strType = val + ''
      console.log(this.strType)
      this.appDetails.app_type = val
    },
    getStroePkgName (id) {
      https.request({
        method: 'get',
        url: '/v2/es/app/storepkgname',
        params: {
          es_pkg_name: id
        }
      }).then(res => {
        if (res.data.store_pkg_name.length === 0) {
          this.appPkgFlag = false
        } else {
          this.appPkgFlag = true
          this.appDetails.app_pkg = res.data.store_pkg_name
        }
      })
    },
    showInfo (item, type) {
      this.appDetails.es_app_pkg = item.package_name
      this.appDetails.app_pkg = ''
      // this.getStroePkgName(item.package_name)
      // if (res.data.store_pkg_name.length === 0) {
      //     this.appPkgFlag = false
      //   } else {
      //     this.appPkgFlag = true
      //     this.appDetails.app_pkg = res.data.store_pkg_name
      //   }
      https.request({
        method: 'get',
        url: '/v2/es/store/app',
        params: {
          es_app_pkg: this.appDetails.es_app_pkg
        }
      }).then(res => {
        if (res.code === 400) {
          console.log(item)
          this.appDetails.app_name = item.store_app_name.length === 0 ? item.name : item.store_app_name
          this.appDetails.app_pkg = item.app_pkg || this.appDetails.app_pkg
          this.appDetails.app_introduce = item.app_introduce || ''
          this.appDetails.app_type = item.app_type || ''
          this.appDetails.app_keyword = item.app_keyword || ''
          this.appDetails.app_description = item.app_description || ''
          this.appDetails.upgrade_remark = item.upgrade_remark || ''
          this.appDetails.app_icon = item.app_icon || ''
          this.appDetails.app_pics = item.app_pics || []
          this.appDetails.privacy_policy = item.privacy_policy || ''
          this.appDetails.operate_type = item.operate_type || []
          this.appDetails.pay_type = item.pay_type || 1
          this.appDetails.language = item.language || 1
          this.appDetails.oper_type = item.oper_type || 1
          this.appDetails.pay_sdk = item.pay_sdk || 1
          this.appDetails.adv_sdk = item.adv_sdk || 1
        } else {
          res.data.operate_type = res.data.operate_type.split(',')
          res.data.app_type = Number(res.data.app_type)
          this.strType = res.data.app_type + ''
          this.appDetails = res.data
          if (res.data.app_pkg.length === 0) {
            this.appPkgFlag = false
          } else {
            this.appPkgFlag = true
          }
        }
      })
      this.isShowInfo = true
      this.flag_type = type
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    aduitText (val) {
      if (val === 0) {
        return '未提审'
      } else if (val === 1) {
        return '待审核'
      } else if (val === 2) {
        return '审核通过'
      } else if (val === 3) {
        return '审核驳回'
      }
    },
    clearUserId () {
      // this.loadData()
    },
    getUserNameAuth () {
      let userNameAuth = sessionStorage.getItem('user_name_auth')
      if (userNameAuth !== null) {
        this.userList.map(item => {
          if (item.label === userNameAuth) {
            this.userInfoId = item.value
            this.loadData(item.value)
            sessionStorage.removeItem('user_name_auth')
          }
        })
      }
    },
    getUserList () {
      let params = {
        page_size: 50,
        page: 1
      }
      https.request({
        method: 'get',
        url: '/v1/account/',
        params: params
      }).then(res => {
        res.data.list.map(item => {
          this.userList.push({
            value: item.id,
            label: item.username
          })
        })
        this.getUserNameAuth()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // getQualification () {
    //   return new Promise(resolve => {
    //     if (parseInt(this.role_id) === 3) {
    //       https.request({
    //         method: 'get',
    //         url: '/v1/qualification/get'
    //       }).then(res => {
    //         let message = ''
    //         if (res.data.aduit_stats === 1) {
    //           message = '您已提交审核信息，请等待审核结果'
    //         } else if (res.data.aduit_stats === 3) {
    //           message = '您提交的信息未通过审核'
    //         } else if (res.data.aduit_stats === 2) {
    //           resolve()
    //           return
    //         } else {
    //           message = '您未提交审核信息</br>建议您先提交审核信息'
    //         }
    //         this.$Modal.confirm({
    //           title: '提示',
    //           content: message,
    //           onOk: () => {
    //             this.$router.push('certification')
    //           },
    //           onCancel: () => {
    //             // this.$router.push('certification')
    //           }
    //         })
    //       }).catch(error => {
    //         this.$Message.error(error)
    //       })
    //     } else {
    //       resolve()
    //     }
    //   })
    // },
    // 加载tabs列表
    loadData (id = '') {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        uid: id,
        name: this.searchAppName,
        package_ver: this.searchAppVer
      }
      https.request({
        method: 'get',
        url: 'v2/es/store/apps',
        params: params
      }).then(res => {
        this.tableLoading = false
        if (res.data.items.length === 0) {
          this.$Modal.confirm({
            title: '提示',
            content: '还没有已经发布版本的快应用可以申请上架',
            onOk: () => {
              this.$router.push('esApp')
            }
          })
        }
        res.data.items.forEach(n => {
          if (n.state === 2) {
            n.state = '禁用'
          } else if (n.state === 1) {
            n.state = '启用'
          }
        })
        this.dataList = res.data.items
        this.total = res.data.count
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    onCopy () {

    },
    uploadImgList (name) {
      let file = this.$refs[name].files
      let length = file.length
      let params = new FormData()
      params.append('type', '2')
      for (let i = 0; i < length; i++) {
        params.append('file', file[i])
      }
      https.request({
        method: 'post',
        // url: '/v2/es/audit/upload/licence',
        url: '/v2/es/store/upload/asset',
        data: params
      }).then(res => {
        // if (!this.appDetails.licenseList) this.appDetails.licenseList = []
        // res.data.forEach(n => {
        console.log(res.data)
        this.appDetails.app_pics.push(res.data[0])
        // })
        console.log(this.appDetails)
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    uploadImg (name, type) {
      let file = this.$refs[name].files
      let length = file.length
      let params = new FormData()
      params.append('type', '2')
      // params.append('file', file[0])
      for (let i = 0; i < length; i++) {
        params.append('file', file[i])
      }
      https.request({
        method: 'post',
        // url: '/v2/es/audit/upload/licence',
        url: '/v2/es/store/upload/asset',
        data: params
      }).then(res => {
        if (type === 'ICON') {
          this.appDetails.app_icon = res.data[0]
        } else if (type === 'PDF') {
          this.appDetails.license_pdf = res.data[0]
        }
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = new FormData()
            params.append('name', this.formValidate.name)
            if (this.formValidate.fileName) params.append('files', this.formValidate.files)
            if (this.formValidate.pre_pwd) params.append('pre_pwd', this.formValidate.pre_pwd)
            params.append('remark', this.formValidate.remark)
            params.append('id', this.editId)
            https.request({
              method: 'post',
              url: '/v1/tvp/edit',
              data: params
            }).then(res => {
              this.$Message.success('提交成功')
              this.newdata = false
              this.loadData()
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    submit (type) {
      this.$refs.appDetails.validate((valid) => {
        if (valid) {
          let params = {
            app_type: ''
          }
          params = {...params, ...this.appDetails}
          params.operate_type = params.operate_type.toString()
          params.app_type = this.strType
          params.action = type
          https.request({
            method: 'post',
            url: '/v2/es/store/upload',
            data: params
          }).then(res => {
            if (res.code === 400) {
              this.$Message.error(res.message)
              this.submitLoading = false
              return
            }
            if (res.code === 200) {
              if (type === 'submit') {
                this.$Message.success('提交成功')
              } else if (type === 'ts') {
                this.$Message.success('保存成功')
              }
              this.submitLoading = false
              this.appDetails = {}
              this.isShowInfo = false
              this.loadData()
            }
            // this.$Message.success({
            //   content: '提交成功',
            //   onClose: () => {
            //     this.loading = false
            //     this.current = 1
            //   }
            // })
          }).catch(error => {
            this.$Message.error(error)
            // this.loading = false
          })
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .input_left{
    // left:516px;
    left:407px;
  }
  .input_left_two{
    // left:700px;
    left:580px;
  }
  .input_left_three{
    // left:885px;
    left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_aduit_info{
    position: absolute;
    top:5px;
    left:5px;
    cursor: pointer;
    z-index:100;
  }
  .app_aduit_updata{
    position: absolute;
    bottom:5px;
    right:5px;
    cursor: pointer;
    z-index:100;
  }
  .app_aduit_channel{
    position: absolute;
    bottom:5px;
    left:5px;
    cursor: pointer;
    z-index:100;
  }
  .app-list-table{
    padding:40px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  .app_details_input_width{
    width:200px;
  }
  .app_details_infobox{
    display: flex;
    flex-flow: wrap;
    align-content: flex-start;
  }
  .picWrap {
    display: inline-block;
    width: 50px;
    position: relative;
    margin-right: 10px;
  }
  .clearPic {
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .app_details_title{
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    margin-bottom:10px;
    background:rgba(204,204,204,0.5);
    line-height: 32px;
    height:32px;
  }
  .back_list{
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/shelfShop.vue